module.exports = __webpack_public_path__ + "img/BlinkArt_Sword5_Gold.433b92e8.png";